/*-----------------------------------------------------------------
- Message translations
-----------------------------------------------------------------*/
export default {

    complete  : 'completed',
    loading   : 'loading',
    pending   : 'pending',
    of_step   : '{0} from {1}',
    on_loading: 'Loading ...',
    empty     : 'This part is empty.',

    error: {
        upload: {
            common: 'There is a problem in the upload.',
        },
    },

    success: {
        upload: {
            common: 'Your file was successfully loaded.',
        },
    },

    cloner: {
        confirm_delete    : 'Are you sure you want to delete this?',
        confirm_delete_all: 'Are you sure you want to delete all items?',
    },

};
